module.exports = __webpack_public_path__ + "img/03.3aa6e6c1.jpg";